// extracted by mini-css-extract-plugin
export default {"centered":"loader_centered__vGJ6H"};